function endTypesMate(a, b) {
  if (!a || !b) return true;
  if (a === "plug" && b === "jack") return true;
  if (a === "jack" && b === "plug") return true;
  if (a === "symmetrical" && b === "symmetrical") return true;
  return false;
}

function cableVoltageOk(cable, sourceVoltageOptions, targetVoltageMin, targetVoltageMax) {
  if (targetVoltageMin == null || targetVoltageMax == null) return true;
  const min = Number(targetVoltageMin);
  const max = Number(targetVoltageMax);

  if (cable.output_voltage) {
    const v = Number(cable.output_voltage);
    return v >= min && v <= max;
  }

  if (!sourceVoltageOptions || sourceVoltageOptions.length === 0) return true;
  return sourceVoltageOptions.some((v) => {
    const volts = Number(v);
    return volts >= min && volts <= max;
  });
}

/**
 * Find the best matching cable from a list of power cables.
 * Returns the cable object or null if no match where input connector,
 * output connector, polarity, and voltage all fit.
 */
export function doublerNeeded(cable, { sourceCurrentMa, targetCurrentMa, sourceVoltageOptions, targetVoltageMin }) {
  if (cable.cable_type === "current_doubler") {
    if (sourceCurrentMa != null && targetCurrentMa != null) {
      return targetCurrentMa > sourceCurrentMa;
    }
    return true; // can't tell, allow it
  }
  if (cable.cable_type === "voltage_doubler") {
    if (sourceVoltageOptions && sourceVoltageOptions.length > 0 && targetVoltageMin != null) {
      const maxSource = Math.max(...sourceVoltageOptions.map(Number));
      return Number(targetVoltageMin) > maxSource;
    }
    return true; // can't tell, allow it
  }
  return true; // not a doubler
}

export function findBestPowerCable(cables, { sourceConnector, targetConnector, targetPolarity, sourceVoltageOptions, targetVoltageMin, targetVoltageMax, sourceEndType, targetEndType, sourceCurrentMa, targetCurrentMa }) {
  if (!cables || cables.length === 0) return null;

  let bestMatch = null;

  for (const cable of cables) {
    const inputMatch = !sourceConnector || !cable.input_connector || cable.input_connector === sourceConnector;
    const outputMatch = !targetConnector || !cable.output_connector || cable.output_connector === targetConnector;
    const polarityMatch = !targetPolarity || !cable.output_polarity || cable.output_polarity === targetPolarity;
    const voltageOk = cableVoltageOk(cable, sourceVoltageOptions, targetVoltageMin, targetVoltageMax);

    const inputEndOk = endTypesMate(cable.input_end_type || "plug", sourceEndType);
    const outputEndOk = endTypesMate(cable.output_end_type || "plug", targetEndType);

    const typeOk = doublerNeeded(cable, { sourceCurrentMa, targetCurrentMa, sourceVoltageOptions, targetVoltageMin });

    if (inputMatch && outputMatch && polarityMatch && voltageOk && inputEndOk && outputEndOk && typeOk) {
      if (cable.cable_type === "standard") return cable;
      if (!bestMatch) bestMatch = cable;
    }
  }

  return bestMatch;
}
